<template>
  <div>
    <v-layout justify-center>
      <v-flex>
        <v-card ref="form">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <span v-if="!!id">Изменить диссертационный совет</span>
              <span v-else> <div>Создать диссертационный совет</div></span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-toolbar-items>
                <v-btn @click="closeDialog" class="pa-0 ma-0" dark flat icon>
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>

            <v-text-field
              :error="hasError('code')"
              :error-messages="getError('code')"
              label="Шифр"
              placeholder="РХТУ.00.00"
              required
              v-model="value.code"
            ></v-text-field>

            <v-layout  v-for="item, i in  value.scientificField" >
              <v-autocomplete
                :error="hasError('scientificField')"
                :error-messages="getError('scientificField')"
                :items="selectors.scientificField"
                label="Научная специальность (по отраслям науки)"
                v-model="item.scientificField"
                no-data-text ="Нет данных"
              ></v-autocomplete>


              <v-btn flat icon class="primary" @click="addscientificField"> <v-icon>add</v-icon></v-btn>
              <v-btn flat icon class="primary" v-if="value.scientificField.length > 1" @click="deleteData(i,'scientificField')"> <v-icon>close</v-icon></v-btn>
            </v-layout>
            <v-alert
              :value="hasError('detail')"
              type="error"
            >
              {{getError('detail')}}
            </v-alert>
            <v-btn @click="apply" color="primary">Сохранить</v-btn>
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

    import urls from "../../../../../modules/petition/urls"
    import UserDataFormMixin from '../../../../../mixins/UserDataFormMixin'
    import {makeGetRequest} from "../../../../../helper";
    import { mask } from 'vue-the-mask'

    export default {
        name: "Dissertation_council",
        mixins: [UserDataFormMixin],
        props: {
            id: Number,
            code:String,
        },
        directives: {
            mask,
        },
        data() {
            return {
              URL_CREATE: urls.getUrl('admin|diss|models|dissertation_council-list', 'list'),
              URL_UPDATE: urls.getUrl('admin|diss|models|dissertation_council-detail', 'update'),

                selectors:{
                    scientificField:[],
                },
                mask: 'РХТУ.XX.XX',
                value: {
                    id: this.id || '',
                    code: this.code || 'РХТУ.',
                    scientificField: [{scientificField:null}],
                },
            }
        },
        watch: {
            $props: {
                handler() {
                    if(this.id){
                        let url =  process.env.VUE_APP_API_HOST +"council/admin/diss/models/dissertation_council/<id>/".replace('<id>',this.value.id)
                        let sys = true
                        makeGetRequest(url).then(resp => {
                            if (!resp.ok) {
                                sys = false
                            }
                            return resp.json()
                        }) .then(json => {

                            url = new URL(urls.getUrl('admin|diss|models|dissertation_council_scientific_field-list', 'list'));
                            let params = json.scientificField.get_params
                            json.scientificField.get_params.page_size = 100
                            url.search = new URLSearchParams(params).toString();
                            sys = true

                            makeGetRequest(url).then(resp => {
                                if (!resp.ok) {
                                    sys = false
                                }
                                return resp.json()
                            }) .then(json => {
                                this.value.scientificField = []
                                for (let key in json) {

                                    this.value.scientificField.push(
                                        {"scientificField": json[key].scientificField}
                                    )
                                }

                            })

                        })
                    }


                },
                deep: true,
                immediate: true,
            },
        },
        methods: {
            closeDialog() {
                this.$emit('ended', '')
            },
            addscientificField(){
                this.value.scientificField.push(
                    {
                        scientificField: null,
                    }
                )
            },
            deleteData(idx, key) {
                if (this.value[key].length > 1)
                    this.value[key].splice(idx, 1);
            },
        },
        created() {
            let url =  urls.getUrl('admin|core|selectors|scientific_field', 'get')
            let sys = true
            makeGetRequest(url).then(resp => {
                if (!resp.ok) {
                    sys = false
                }
                return resp.json()
            }) .then(json => {
                this.selectors.scientificField = json
            })

        }
    }

</script>

<style scoped>

</style>
